import "./Culture.css";

const Culture = () => {
  return (
    <div className="culture-container">
      <h1 className="culture-title">DRIVEN BY CULTURE & VALUES</h1>

      <p className="culture-desc">
        At VENSAP Composite, our culture is built on integrity, sustainability,
        and continuous innovation. We empower our people and create an
        environment where collaboration and creativity flourish. Through ethical
        practices and a people-first mindset, we strive to make a positive
        impact on our community and the environment.
      </p>

      <div className="culture-cards">
        <div className="culture-card">
          <img
            src="/assets/features/Teammembers.png"
            alt="Teamwork"
            className="culture-icon"
          />
          <h3>Teamwork</h3>
          <p>
            We work as one team, encouraging mutual support to achieve common
            goals.
          </p>
        </div>

        <div className="culture-card">
          <img
            src="/assets/features/Innovation.png"
            alt="Innovation"
            className="culture-icon"
          />
          <h3>Innovation</h3>
          <p>
            Driving innovation to develop solutions that align with industry
            demands and enable long-term growth.
          </p>
        </div>

        <div className="culture-card">
          <img
            src="/assets/features/Customerfocus.png"
            alt="Customer Focus"
            className="culture-icon"
          />
          <h3>Customer Focus</h3>
          <p>
            We are committed to understanding customer needs and delivering
            reliable, high-quality solutions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Culture;
